import { LoadState } from "../../constants/enums";

export interface IEventsState {
  list: {
    list: IEvent[];
    totalRecords: number;
    loading: LoadState;
    error: string | null;
  };
  event: {
    data: IEvent;
    loading: LoadState;
    error: string | null;
  };
}

export interface IEvent {
  event_type_unique_id: number;
  event_type_uuid: string;
  name: string;
  event_date: string;
  event_type: string;
  location: string;
  is_registered: boolean;
  event_time: string;
  remarks: string;
  status: "ACTIVE" | "INACTIVE";
  company_outlet_uuid: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
  create_ts: string;
  insert_ts: string;
}

export const initialEvent: IEvent = {
  event_type_unique_id: 0,
  event_type_uuid: "",
  name: "",
  event_date: new Date().toISOString(),
  event_type: "",
  location: "",
  is_registered: false,
  event_time: "",
  remarks: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const initialEventsState: IEventsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  event: {
    data: initialEvent,
    loading: LoadState.NotLoaded,
    error: null,
  },
}; 